<template>
  <div>
    <div class="boires-page-loader-div" v-if="isLoading">
      <div class="boires-page-loader"></div>
    </div>
    <MainLayout v-else>
      <div :class="[isMobileLayout ? 'container' : 'blog-container']">
        <PreviousPageBtn :label-code="'blog'" />
        <div>
          <mq-layout :mq="['xs', 'sm', 'md']">
            <el-row>
              <el-col :span="24">
                <a v-if="blog.type.code == 'VIDEO'" :href="blog.videoLink" data-fancybox="blog-gallery">
                <el-row
                  name="card-row"
                  :class="[
                    isCarousel
                      ? carouselType === 2
                        ? 'carousel__video--height'
                        : carouselType === 1
                        ? 'carousel__texte--height '
                        : 'carousel__image-size'
                      : '',
                    '',
                  ]"
                >
                  <el-col
                    :class="[
                      isCarousel
                        ? carouselType === 2
                          ? 'carousel__video--height carousel__video--width'
                          : carouselType === 1
                          ? 'carousel__texte--height carousel__texte--width'
                          : 'carousel__image-size'
                        : '',
                      'position-relative',
                    ]"
                  >
                    <div
                      :class="[
                        isCarousel
                          ? carouselType === 2
                            ? 'carousel__video--height carousel__video--width'
                            : carouselType === 1
                            ? 'carousel__texte--height carousel__texte--width'
                            : 'blog-background__carousel'
                          : 'blog-background thumbnail-image',
                      ]"
                      v-bind:style="{ backgroundImage: 'url(' + thumbnail + ')' }"
                    ></div>
                    <img :src="thumbnail" class="blog-image__dimension"/>
                    <div class="position-absolute blog-play-btn">
                      <img :src="playBtn" />
                    </div>
                  </el-col>
                </el-row>
              </a>
                <el-image
                  v-if="changeBlogimage && blog.type.code != 'VIDEO'"
                  class="blog-image__dimension"
                  :src="thumbnail"
                  :fit="'cover'"
                />
              </el-col>
            </el-row>
            <div :span="12" class="">
              <BlogTitle
                :blog="blog"
                class="blog-infos__position blog-title__dimension"
              />
              <!-- <SocialMediaBar :title="title" /> -->
            </div>
          </mq-layout>
          <mq-layout mq="lg+">
            <el-row>
              <el-col :span="12">
                <a v-if="blog.type.code == 'VIDEO'" :href="blog.videoLink" data-fancybox="blog-gallery">
                <el-row
                  name="card-row"
                  :class="[
                    isCarousel
                      ? carouselType === 2
                        ? 'carousel__video--height'
                        : carouselType === 1
                        ? 'carousel__texte--height '
                        : 'carousel__image-size'
                      : '',
                    '',
                  ]"
                >
                  <el-col
                    :class="[
                      isCarousel
                        ? carouselType === 2
                          ? 'carousel__video--height carousel__video--width'
                          : carouselType === 1
                          ? 'carousel__texte--height carousel__texte--width'
                          : 'carousel__image-size'
                        : '',
                      'position-relative',
                    ]"
                  >
                    <div
                      :class="[
                        isCarousel
                          ? carouselType === 2
                            ? 'carousel__video--height carousel__video--width'
                            : carouselType === 1
                            ? 'carousel__texte--height carousel__texte--width'
                            : 'blog-background__carousel'
                          : 'blog-background thumbnail-image',
                      ]"
                      v-bind:style="{ backgroundImage: 'url(' + thumbnail + ')' }"
                    ></div>
                    <img :src="thumbnail" class="blog-image__dimension"/>
                    <div class="position-absolute blog-play-btn">
                      <img :src="playBtn" />
                    </div>
                  </el-col>
                </el-row>
              </a>
                <el-image
                  v-if="changeBlogimage && blog.type.code != 'VIDEO'"
                  class="blog-image__dimension"
                  :src="thumbnail"
                  :fit="'cover'"
                />
              </el-col>
              <el-col :span="12" class="rectangle">
                <BlogTitle
                  :blog="blog"
                  class="blog-infos__position blog-title__dimension"
                />
                <!-- <SocialMediaBar :title="title" /> -->
              </el-col>
            </el-row>
          </mq-layout>
          <div
            :class="[
              isMobileLayout ? 'blog-content--mobile' : 'blog-content',
              'blog-infos__paragraph paragraph1 mt-60 mb-100',
            ]"
          >
            <!-- eslint-disable-next-line -->
            <div class="text-left paragraph1 mb-20 paragraph-content" v-html="content" />
            <div class="text-left paragraph1 mb-20 author-name" v-html="author" />
            <el-row
              v-if="imageSrcList.length > 0"
              :gutter="10"
              class="blog-content__gallery mt-40"
            >
              <el-col v-for="image in imageSrcList" :key="image.id" :span="8" class="mb-10">
                <el-image :class="[ isMobileLayout ? 'blog-content__image--mobile' : 'blog-content__image',]"
                  :src="image.thumbnailLink"
                  :preview-src-list="[image.link]"
                  :fit="'cover'"
                />
              </el-col>
            </el-row>
          </div>
          <div v-if="blogProducts.length > 0" class="mt-30 mb-60">
            <ProductCarousel
              :products="sortedBlogProducts"
              :tax-code="actionBar && actionBar.tax"
              arrow="always"
            />
          </div>
        </div>
      </div>
    </MainLayout>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { get } from "@/utils/lodash";
import layoutUtils from "@/utils/layout-utils";
import { scrollUp } from "@/utils/common-utils";
import errorUtils from "@/utils/error-utils";
import ProductApi from "@/api/product";

import MainLayout from "@/components/layout/main-layout.vue";
import PreviousPageBtn from "@/components/previous-page-btn.vue";
// import SocialMediaBar from "@/components/social-media-bar.vue";
import ProductCarousel from "@/views/product/components/product-carousel.vue";
import { sortByHierarchyWithAlternation, enrichProductsForMarket } from "@/utils/carousel-sort-utils";
import { getDefaultAvailability } from "@/utils/market-utils";

import imgBlogDefault from "@/assets/images/provider/provider-default.png";
import playBtn from "@/assets/images/blog/video/blog-video-triangle-small.svg";
import BlogTitle from "./components/blog-title.vue";

export default {
  components: {
    BlogTitle,
    MainLayout,
    PreviousPageBtn,
    ProductCarousel,
    // SocialMediaBar,
  },
  props: {
    slug: {
      type: String,
      default: null,
    },
    id: {
      // type: Number,
      default: null,
    },
    isCarousel: {
      type: Boolean,
      default: false,
    },
    carouselType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      images: {
        blogDefault: {
          src: imgBlogDefault,
        },
      },
      changeBlogimage: true,
      getLang: this.$i18n.locale,
      isLoading: true,
      playBtn,
      blogProducts: [],
    };
  },
  computed: {
    ...mapState("blog", ["blog"]),
    ...mapState("configuration", ["actionBar"]),
    sortedBlogProducts() {
      const market = localStorage.getItem("countryCode") || "QC";
      const enriched = enrichProductsForMarket(this.blogProducts, market);
      return sortByHierarchyWithAlternation(enriched, market);
    },
    thumbnail() {
      const thumbnail = get(this.blog, "mainImage.link");

      if (thumbnail == null) {
        return this.images.blogDefault.src;
      }

      return thumbnail;
    },
    content() {
      return get(this.blog, "content", "");
    },
    // relatedArticlesLabel() {
    //   return this.$i18n.t("blogs.blogView.label.relatedArticles");
    // },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    imageSrcList() {
      const images = get(this.blog, "images", []);
      return images;
    },
    title() {
      return get(this.blog, "title", "");
    },
    author() {
      const author = `<span class="author">By</span> ${get(this.blog, "user.firstName")} ${get(
        this.blog,
        "user.lastName"
      )}`;

      return author != null ? author : "";
    },
    theme() {
      const attr = find(
        get(this.blog, "attributes"),
        (x) => get(x, "type.code") === "BLOG_THEME"
      );
      const val = get(attr, "value");

      if (val != null) {
        return val;
      }

      return "";
    },
  },
  created() {
    this.resetState();
    const isNumericId = /^\d+$/.test(this.slug);
    if (isNumericId) {
      this.getBlogByIdAndRedirect(this.slug);
    } else {
      this.getBlog(this.slug, "slug");
    }
  },
  mounted() {
    scrollUp();
    this.$root.$on("chanLang", () => {
      this.changeBlogimage = false;
      this.getLang = this.$i18n.locale;
      this.$nextTick(() => {
        this.changeBlogimage = true;
      });
    });
  },
  watch: {
    getLang() {
      const blogId = get(this.blog, "id");
      if (blogId != null) {
        this.fetchBlog({ id: blogId, idType: "id" })
          .then(() => {
            const newSlug = get(this.blog, "slug");
            if (newSlug && newSlug !== this.slug) {
              this.$router.replace({ name: "blog", params: { slug: newSlug } });
            }
            this.fetchRelatedProducts();
          })
          .catch((error) => {
            if (errorUtils.extractErrorHttpStatusCode(error) === 404) {
              this.$router.push({ name: "notFound", query: { type: "blogs" } });
            }
          });
      } else {
        this.getBlog(this.slug, /^\d+$/.test(this.slug) ? "id" : "slug");
      }
    },
  },
  methods: {
    ...mapActions("blog", ["fetchBlog"]),
    ...mapMutations("blog", ["resetState"]),
    getBlogByIdAndRedirect(id) {
      this.isLoading = true;
      this.fetchBlog({ id, idType: "id" })
        .then(() => {
          const blogSlug = get(this.blog, "slug");
          if (blogSlug) {
            this.$router.replace({ name: "blog", params: { slug: blogSlug } });
          }
          this.isLoading = false;
          this.fetchRelatedProducts();
        })
        .catch((error) => {
          this.isLoading = false;
          if (errorUtils.extractErrorHttpStatusCode(error) === 404) {
            this.$router.push({ name: "notFound", query: { type: "blogs" } });
          }
        });
    },
    getBlog(id, idType) {
      this.isLoading = true;
      this.fetchBlog({
        id,
        idType,
      })
        .then(() => {
          this.isLoading = false;
          this.fetchRelatedProducts();
        })
        .catch((error) => {
          this.isLoading = false;
          if (errorUtils.extractErrorHttpStatusCode(error) === 404) {
            this.$router.push({
              name: "notFound",
              query: {
                type: "blogs",
              },
            });
          }
        });
    },
    async fetchRelatedProducts() {
      const relatedProducts = get(this.blog, "relatedProducts", []);
      if (!relatedProducts || relatedProducts.length === 0) {
        this.blogProducts = [];
        return;
      }
      try {
        const cmsProducts = await Promise.all(
          relatedProducts.map((rp) => ProductApi.fetchCmsProduct(rp.id).catch(() => null))
        );
        // The ES product response has no top-level puid: a product can have
        // several puids (one per inventory variant), listed under
        // productInventories[].puid. Sold-out products have an empty array and
        // simply drop out, same as their dead puid returned no results before.
        const puids = cmsProducts
          .filter(Boolean)
          .flatMap((p) => (p.productInventories || []).map((pi) => pi.puid))
          .filter(Boolean);
        if (puids.length === 0) {
          this.blogProducts = [];
          return;
        }
        const data = await ProductApi.fetchProductsByPuid(puids);
        // The puid list now spans every market's variants, so the same wine can
        // come back once per inventory (QC + ON). Keep one card per product,
        // preferring the variant sold in the visitor's market — same fetch-time
        // market filtering the boutique/agency listings apply via `inventory`.
        const market = localStorage.getItem("countryCode") || "QC";
        const allowedCodes = getDefaultAvailability(market).map((c) => c.toUpperCase());
        const isInMarket = (p) =>
          allowedCodes.indexOf(get(p, "inventory.code", "").toUpperCase()) !== -1;
        const byProduct = new Map();
        get(data, "results", []).forEach((p) => {
          const key = p.id != null ? p.id : p.puid;
          const current = byProduct.get(key);
          if (!current || (isInMarket(p) && !isInMarket(current))) {
            byProduct.set(key, p);
          }
        });
        this.blogProducts = Array.from(byProduct.values());
      } catch {
        this.blogProducts = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

$blog-image-size-xs: 100%;
$blog-image-size-sm: 383px;
$blog-image-size-md: 470px;
$blog-image-size-lg: 550px;
$logo-dimension: 80px;
$related-article-image-lg: 372px;
$related-article-image-md: 320px;
$related-article-image-sm: 400px;
$blog-content-image-lg: 189px;
$blog-content-image-sm: 121px;

.blog-container {
  // sm -
  @media screen and (max-width: $media-md) {
    margin: 0;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: $container-max-width-md;
    margin-left: auto;
    margin-right: auto;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: $container-max-width-lg;
    margin-left: auto;
    margin-right: auto;
  }
}
.blog-image__dimension {
  // sm -
  @media screen and (max-width: $media-md) {
    height: $blog-image-size-sm;
    width: $blog-image-size-sm;
  }
  //xs -
  @media screen and (max-width: $media-sm) {
    height: $blog-image-size-xs;
    width: $blog-image-size-xs;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    height: $blog-image-size-md;
    width: $blog-image-size-md;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    height: $blog-image-size-lg;
    width: $blog-image-size-lg;
  }
}
.rectangle {
  background-color: rgba(237, 240, 237, 0.33);
  padding-bottom: 2px;
  margin-left: -15px;
  padding-left: 40px;
}
.blog-infos__position {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: center;
}
.blog-title__dimension {
  // sm -
  @media screen and (max-width: $media-md) {
    width: $blog-image-size-sm;
  }
  // xs -
  @media screen and (max-width: $media-md) {
    width: auto;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: $blog-image-size-md;
    height: $blog-image-size-md;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: $blog-image-size-lg;
    height: $blog-image-size-lg;
  }
}
.blog-infos__position--mobile {
  justify-content: flex-start;
}
.blog-infos__paragraph {
  margin-left: auto;
  margin-right: auto;
  // xs -
  @media screen and (max-width: $media-md) {
    width: auto !important;
  }
}
.subtitle2__color {
  color: $color-on-background-area1;
}
.blog-content {
  width: 80%;
  display: inline-flex;
  flex-direction: column;
  .paragraph1{
    font-size: 20px;
    //  p {
    //   text-align: justify !important;
    //   margin-bottom: 20px;
    // }
  }

}
.author-name {
  background: lightgray;
  padding: 12px;
  // width: max-content;
  color: rgba(39, 36, 33, .7);
}
.blog-content--mobile {
  width: 383px;
  .paragraph1{
    font-size: 20px;
  }
}
.blog-content__image {
  width: 98%;
  aspect-ratio: 1 / 1;
}
.blog-content__image--mobile {
  width: $blog-content-image-sm;
  height: $blog-content-image-sm;
}
.blog-content__gallery {
  width: 100%;
}
.related-articles__image {
  // sm -
  @media screen and (max-width: $media-md) {
    height: $related-article-image-sm;
    width: $related-article-image-sm;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    height: $related-article-image-md;
    width: $related-article-image-md;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    height: $related-article-image-lg;
    width: $related-article-image-lg;
  }
}
</style>
